// extracted by mini-css-extract-plugin
export var par = "SubMainTitle-module--par--pp9V9";